import { render } from "./postsContent.vue?vue&type=template&id=20c34a84&scoped=true"
import script from "./postsContent.vue?vue&type=script&lang=js"
export * from "./postsContent.vue?vue&type=script&lang=js"

import "./css/antd.css?vue&type=style&index=0&lang=css"
import "./postsContent.vue?vue&type=style&index=1&id=20c34a84&lang=css"
import "./postsContent.vue?vue&type=style&index=2&id=20c34a84&scoped=true&lang=scss"
import "./postsContent.vue?vue&type=style&index=3&id=20c34a84&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c34a84"]])

export default __exports__